import { render, staticRenderFns } from "./VDeal.vue?vue&type=template&id=bfa01ad4&"
import script from "./VDeal.vue?vue&type=script&lang=js&"
export * from "./VDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa01ad4')) {
      api.createRecord('bfa01ad4', component.options)
    } else {
      api.reload('bfa01ad4', component.options)
    }
    module.hot.accept("./VDeal.vue?vue&type=template&id=bfa01ad4&", function () {
      api.rerender('bfa01ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VDeal/VDeal.vue"
export default component.exports